import React from 'react';
import styles from './StudyTasks.scss';
import lodash from 'lodash';
import DateTime from 'common/components/DateTime/DateTime';
import moment from 'moment';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Tabs } from 'components/common/Tabs/Tabs';
import {
    getTasks,
    unloadTasks,
} from 'pages/studyOverview/actions/tasks.js';

import ListHelperText from 'components/common/Helper/ListHelper';
import Table from 'components/common/Table/Table';
import { LoadingStatus } from 'components/common/LoadingStatus/LoadingStatus';

import {
    DOA_TYPE_TASK,
    EVENT_TYPE_TASK,
    SDFA_TYPE_TASK
} from 'common/util/taskHelper';

import {
    getAllCompletedStudyTasks,
    getAllPendingStudyTasks,
    getAllTasksCount,
} from 'pages/studyOverview/selectors/tasks';
import { loadHomePageV4Access } from '../../../../common/features/predicates';

class StudyTasks extends React.Component {

    constructor(props) {
        super(props);

        this.state = { tabs: [], };
    }

    componentDidMount() {
        const { binderId, studyId, getTasks, taskCount: count } = this.props;

        getTasks(binderId, studyId, 'pending');
        getTasks(binderId, studyId, 'completed');

        this.setState({
            tabs: [{
                label: `Pending Tasks  -  ${count.pending}`,
                path: `/study/${studyId}/tasks/pending`,
                backgroundHighlight: true,
            }, {
                label: `Completed Tasks  -  ${count.completed}`,
                path: `/study/${studyId}/tasks/completed`,
                backgroundHighlight: true,
            }],
        });
    }

    componentWillReceiveProps(nextProps) {
        const { studyId, taskCount: count } = this.props;
        if (!lodash.isEqual(nextProps.taskCount.pending, count.pending)
            || !lodash.isEqual(nextProps.taskCount.completed, count.completed)) {
            this.setState({
                tabs: [{
                    label: `Pending Tasks  -  ${nextProps.taskCount.pending}`,
                    path: `/study/${studyId}/tasks/pending`,
                    backgroundHighlight: true,
                }, {
                    label: `Completed Tasks  -  ${nextProps.taskCount.completed}`,
                    path: `/study/${studyId}/tasks/completed`,
                    backgroundHighlight: true,
                }],
            });
        }
    }

    goToTask(task) {
        const { binderId, institutionId } = this.props;

        let path = '';
        switch (task.taskType) {
            case DOA_TYPE_TASK:
                path = `/form/doa/${task.id}?taskBox=sent`;
                break;
            case EVENT_TYPE_TASK:
                path = `/form/event/${task.id}?taskBox=sent`;
                break;
            case SDFA_TYPE_TASK:
                path = `/form/processSummary/sdfa?workflowId=${task.id}&binderId=${binderId}&iid=${institutionId}`;
                break;
            default:
                throw new Error(`Unsupported task type of ${task.taskType}`);
        }

        this.props.push(path);
    }

    componentWillUnmount() {
        unloadTasks();
    }

    renderLoadingState() {
        const { loading, complion4FlagEnabled } = this.props;

        return (loading ? <LoadingStatus loading={true} itemName={`${complion4FlagEnabled ? 'Binder' : 'Study'} Tasks`} /> : this.renderTasks());
    }

    renderTasks() {
        const { router, pendingTasks, completedTasks, complion4FlagEnabled } = this.props;

        if (router.location.pathname.endsWith('pending')) {
            return (pendingTasks.length > 0
                ?
                <Table
                    columns={pendingColumns}
                    data={pendingTasks}
                    rowClickHandler={this.goToTask.bind(this)}
                    data-cy="StudyTasks" />
                :
                <div className={styles.helperText} data-cy="StudyTasks-div">
                    <ListHelperText
                        primaryText={`No pending ${complion4FlagEnabled ? 'binder' : 'study'} tasks available.`} />
                </div>
            );
        } else if (router.location.pathname.endsWith('completed')) {
            return (completedTasks.length > 0
                ?
                <Table
                    columns={completedColumns}
                    data={completedTasks}
                    rowClickHandler={this.goToTask.bind(this)}
                    data-cy="StudyTasks-tabl" />
                :
                <div className={styles.helperText} data-cy="StudyTasks-divs">
                    <ListHelperText
                        primaryText={`No completed ${complion4FlagEnabled ? 'binder' : 'study'} tasks available.`} />
                </div>
            );
        }
    }

    render() {
        const { tabs, } = this.state;

        return (
            <div data-cy="StudyTasks-render">
                <div className={styles.studyNavigationContainer}>
                    <h1 className={styles.taskTitle}>{this.props.complion4FlagEnabled ? 'Binder' : 'Study'} Tasks</h1>
                    <Tabs tabs={tabs} location={location} />
                </div>
                {this.renderLoadingState()}
            </div >
        );
    }
}

export default connect(state => {
    const binderId = lodash.get(state, 'study.binderId', null);
    const studyId = lodash.get(state, 'study.id', null);
    const institutionId = lodash.get(state, 'study.institutionId', null);
    const loading = lodash.get(state, 'study.tasks.loading', true);
    const pendingTasks = getAllPendingStudyTasks(state);
    const completedTasks = getAllCompletedStudyTasks(state);
    const taskCount = getAllTasksCount(state);

    return {
        binderId,
        studyId,
        institutionId,
        loading,
        completedTasks,
        pendingTasks,
        taskCount,
        complion4FlagEnabled: loadHomePageV4Access(state),
    };
}, {
    getTasks,
    unloadTasks,
    push,
})(StudyTasks);


const pendingColumns = [{
    header: 'Task Title',
    accessor: 'title',
    styles: {
        width: '40%',
    },
    component: task => {
        return (
            <div data-cy="StudyTasks-component">
                <span style={{ fontSize: '16px', fontWeight: '600', color: '#0056ad' }}>{task.title}</span>
            </div>
        );
    }
}, {
    header: 'Type',
    accessor: 'documentType',
    styles: {
        width: '22%',
    }
}, {
    header: 'Assigned By',
    accessor: 'authorDisplayName',
    styles: {
        width: '22%',
        maxWidth: '12rem',
        wordBreak: 'break-word',
    }
}, {
    header: 'Completed Actions',
    accessor: 'completePercentage',
    styles: {
        width: 'auto',
        margin: 'auto',
        overflow: 'visible',

    },
    component: task => {
        const completedInstances = lodash.get(task, 'completedInstances', '0');
        const incompletedInstances = lodash.get(task, 'activeInstances', '1');
        return (
            <div data-cy="StudyTasks-pendingColumns">
                <span style={{ color: '#0056ad', fontSize: '16px', fontWeight: '600' }} data-cy="StudyTasks-completedInstances">{completedInstances}</span>
                <span style={{ color: '#8FA0B3', fontSize: '16px', fontWeight: '600' }} data-cy="StudyTasks-incompletedInstances"> of {parseInt(completedInstances) + parseInt(incompletedInstances)}</span>
            </div>
        );
    }
}, {
    header: 'Days Since Assigned',
    accessor: 'daysSinceAssigned',
    styles: {
        width: 'auto',
        margin: 'auto',
        overflow: 'visible',
    },
    component: task => {
        const sentDate = moment(task.sentDate);
        const today = moment();

        return (
            <div data-cy="StudyTasks-pendingColumn">
                <span style={{ color: '#0056ad', fontSize: '16px', fontWeight: '600' }} data-cy="StudyTasks-sentDate">{today.diff(sentDate, 'days')}</span>
            </div>
        );
    },
}];

const completedColumns = [{
    header: 'Task Title',
    accessor: 'title',
    styles: {
        width: '40%',
    },
    component: task => {
        return (
            <div>
                <span style={{ fontSize: '16px', fontWeight: '600', color: '#0056ad' }}>{task.title}</span>
            </div>
        );
    }
}, {
    header: 'Type',
    accessor: 'documentType',
    styles: {
        width: '22%',
    }
}, {
    header: 'Assigned By',
    accessor: 'authorDisplayName',
    styles: {
        width: '22%',
        maxWidth: '12rem',
        wordBreak: 'break-word',
    }
}, {
    header: 'Completed Actions',
    accessor: 'finishedTask',
    styles: {
        width: 'auto',
        marginLeft: 'auto',
        overflow: 'visible',
    },
    component: task => {
        return (
            <div data-cy="StudyTasks-task">
                <span style={{ fontSize: '16px', fontWeight: '600', color: '#0056ad' }} data-cy="StudyTasks-span">{task.completedInstances}</span>
            </div>
        );
    }
}, {
    header: 'Completion Date',
    accessor: 'endDate',
    styles: {
        width: 'auto',
        marginLeft: 'auto',
        overflow: 'visible',
    },
    component: task => {
        return (
            <DateTime
                time={false}
                style={{ fontSize: '16px', color: '#0056ad', fontWeight: '600' }}
                format={'MMM D, YYYY'}
                value={task.endDate}
                data-cy="StudyTasks-DateTime"
            />
        );
    }
}];
